import React, { useState, useRef, useEffect } from 'react';
import TooltipPortal from './TooltipPortal';
import { translations } from '../../i18n/translations';

const WarningIcon = ({ issues, className = "", lingua = 'it' }) => {
  const lang = (lingua && translations[lingua]) ? lingua : 'it';
  const issueLabel = translations[lang]?.validation?.issuesList || 'Problemi:';
  const [showTooltip, setShowTooltip] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const iconRef = useRef(null);

  const updatePosition = () => {
    if (iconRef.current) {
      const rect = iconRef.current.getBoundingClientRect();
      setPosition({
        x: rect.left - 15,
        y: rect.top + (rect.height / 2)
      });
    }
  };

  useEffect(() => {
    // Aggiorna la posizione quando il componente viene montato o quando le dimensioni della finestra cambiano
    if (!issues || issues.length === 0) return;
    window.addEventListener('resize', updatePosition);
    updatePosition(); // Imposta la posizione iniziale

    return () => {
      window.removeEventListener('resize', updatePosition);
    };
  }, [issues]);

  if (!issues || issues.length === 0) return null;

  return (
    <>
      <div
        ref={iconRef}
        className={`relative ${className}`}
        onMouseEnter={() => {
          updatePosition();
          setShowTooltip(true);
        }}
        onMouseLeave={() => setShowTooltip(false)}
      >
        <div className="flex items-center justify-center w-8 h-8 hover:scale-110 transition-transform cursor-help">
          <svg
            className="w-8 h-8"
            viewBox="0 0 176 176"
            xmlns="http://www.w3.org/2000/svg"
          >
            <polygon
              className="fill-amber-400"
              points="22.5,20.1 156.4,20.1 156.4,154 22.5,154 22.5,20.1"
            />
            <path
              className="fill-white"
              d="M101.5,124.4c0-6.5-5.3-11.8-11.8-11.8c-6.5,0-11.8,5.3-11.8,11.8c0,6.5,5.3,11.8,11.8,11.8 C96.2,136.1,101.5,130.9,101.5,124.4L101.5,124.4L101.5,124.4z M101,50.6c0-0.3,0-0.6,0-0.9c0-6.5-5.3-11.8-11.8-11.8 c-6.5,0-11.8,5.3-11.8,11.8c0,0.3,0,0.6,0,0.9l5.9,49c0.4,3.1,3,5.5,6.2,5.5c3.1,0,5.7-2.3,6.2-5.3l5.2-48.7l0-0.3L101,50.6 L101,50.6L101,50.6z"
            />
          </svg>
        </div>
      </div>

      {/* Tooltip renderizzato nel portal */}
      <TooltipPortal show={showTooltip}>
        <div
          className="fixed z-[9999] px-3 py-2 bg-gray-900 text-white text-xs rounded-lg shadow-lg max-w-xs md:max-w-sm pointer-events-none"
          style={{
            right: `${window.innerWidth - position.x}px`,
            top: `${position.y}px`,
            transform: 'translateY(-50%)'
          }}
        >
          {/* Freccia */}
          <div
            className="absolute top-1/2 left-full transform -translate-y-1/2 w-0 h-0"
            style={{
              borderLeft: '6px solid #111827',
              borderTop: '6px solid transparent',
              borderBottom: '6px solid transparent'
            }}
          />

          <div className="font-semibold mb-1 text-amber-300">⚠️ {issueLabel}</div>
          {issues.map((issue, index) => (
            <div key={index} className="mb-1 last:mb-0">
              • {issue}
            </div>
          ))}
        </div>
      </TooltipPortal>
    </>
  );
};

export default WarningIcon;